module.exports = __webpack_public_path__ + "img/fаlag-pl.0f229036.svg";